<template>
    <div>
        <!-- 预付款抵扣审核/详情界面 -->
        <el-dialog v-dialog-drag :visible.sync="showDialog" width="950px" :destroy-on-close="true" :before-close="cancel"
            :title="type === 'audit' ? '预付款抵扣审核' : '预付款抵扣详情'" class="change-detail-dialog">
            <div class="el-dialog-div">
                <!-- 审核操作 -->
                <div class="section-card audit-section" v-if="type === 'audit'">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
                        <el-button size="small" type="success" icon="el-icon-check"
                            @click="handleApprove">确认审核</el-button>
                    </div>
                    <el-form :model="form" label-width="100px" ref="form" :rules="rules" class="audit-form">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="审核状态" prop="status">
                                    <el-radio-group v-model="form.status">
                                        <el-radio label="SUCCESS" class="success-radio">
                                            <i class="el-icon-success" style="color: #67c23a;"></i> 通过
                                        </el-radio>
                                        <el-radio label="DEFEAT" class="danger-radio">
                                            <i class="el-icon-error" style="color: #f56c6c;"></i> 拒绝
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="form.status === 'DEFEAT'">
                            <el-col :span="24">
                                <el-form-item label="驳回理由" prop="rejectionReason">
                                    <el-input type="textarea" v-model="form.rejectionReason" placeholder="请输入预付款抵扣驳回理由"
                                        :rows="3" maxlength="500" show-word-limit></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 抵扣信息 -->
                <div class="section-card">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-coin"></i> 抵扣信息</span>
                        <el-button size="mini" type="text"
                            :icon="sectionOpen.offsetInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                            @click="toggleSection('offsetInfo')">{{ sectionOpen.offsetInfo ? '收起' : '展开' }}</el-button>
                    </div>
                    <div v-show="sectionOpen.offsetInfo" class="section-body">
                        <div class="detail-grid">
                            <div class="detail-item">
                                <span class="detail-label">申请人</span>
                                <span class="detail-value">{{ selectDetail.sponsor || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">申请时间</span>
                                <span class="detail-value">{{ selectDetail.createTime || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同金额</span>
                                <span class="detail-value amount-text">{{ formatAmount(recordData.contractAmount)
                                }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">申请抵扣金额</span>
                                <span class="detail-value amount-text">{{ formatAmount(applyData.offsetAmount) }}</span>
                            </div>

                            <div class="detail-item full-width">
                                <span class="detail-label">申请备注</span>
                                <span class="detail-value">{{ applyData.remark || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 审核信息（详情模式且已审核时展示） -->
                <div class="section-card"
                    v-if="type !== 'audit' && selectDetail.status && selectDetail.status !== 'APPLYING'">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-s-check"></i> 审核信息</span>
                        <el-button size="mini" type="text"
                            :icon="sectionOpen.auditInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                            @click="toggleSection('auditInfo')">{{ sectionOpen.auditInfo ? '收起' : '展开' }}</el-button>
                    </div>
                    <div v-show="sectionOpen.auditInfo" class="section-body">
                        <div class="detail-grid">
                            <div class="detail-item">
                                <span class="detail-label">审批人员</span>
                                <span class="detail-value">{{ selectDetail.operator || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">审核时间</span>
                                <span class="detail-value">{{ selectDetail.auditTime || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">审核状态</span>
                                <span class="detail-value">
                                    <el-tag :type="getStatusColor(selectDetail.status, 'tagType')" :style="{
                                        color: getStatusColor(selectDetail.status, 'color'),
                                        'background-color': getStatusColor(selectDetail.status, 'backgroundColor')
                                    }">
                                        {{ getStatusColor(selectDetail.status, 'name') }}
                                    </el-tag>
                                </span>
                            </div>
                            <div class="detail-item full-width">
                                <span class="detail-label">审批意见</span>
                                <span class="detail-value">{{ selectDetail.rejectionReason || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 合同基础信息 -->
                <div class="section-card">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-document"></i> 合同基础信息</span>
                        <el-button size="mini" type="text"
                            :icon="sectionOpen.contractInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                            @click="toggleSection('contractInfo')">{{ sectionOpen.contractInfo ? '收起' : '展开' }}</el-button>
                    </div>
                    <div v-show="sectionOpen.contractInfo" class="section-body">
                        <div class="detail-grid">
                            <div class="detail-item">
                                <span class="detail-label">合同编号</span>
                                <span class="detail-value contract-number-text">{{ recordData.contractNumber || '-'
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">执行合同编号</span>
                                <span class="detail-value">{{ recordData.executeContractNumber || 'NA' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同名称</span>
                                <span class="detail-value">{{ recordData.contractName || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同类型</span>
                                <span class="detail-value">{{ recordData.projectType || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同分类</span>
                                <span class="detail-value">
                                    <el-tag size="mini" :type="getContractColor(recordData.contractType, 'tagType')"
                                        :style="{
                                            color: getContractColor(recordData.contractType, 'color'),
                                            'background-color': getContractColor(recordData.contractType, 'backgroundColor')
                                        }">
                                        {{ getContractColor(recordData.contractType, 'name') }}
                                    </el-tag>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">销售</span>
                                <span class="detail-value">{{ recordData.sales ? recordData.sales.name : '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">委托方（甲方）</span>
                                <span class="detail-value contact-text">{{
                                    recordData.customerContacts ? recordData.customerContacts.contactName : '-'
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">受托方（乙方）</span>
                                <span class="detail-value">{{ recordData.baseCompany ?
                                    recordData.baseCompany.companyName : '-' }}</span>
                            </div>
                            <div class="detail-item full-width">
                                <span class="detail-label">签订地点</span>
                                <span class="detail-value">{{ recordData.signingPlace || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <loading :loading="loading" load-text="提交中"></loading>
        </el-dialog>
    </div>
</template>

<script>
import { auditInfo } from "@/api/dilivery/audit";
import { getContractColor, getStatusColor } from "@/color";
import Loading from "@/components/loading/Loading.vue";
import detailCommonMixin from "@/mixins/detailCommonMixin";

export default {
    name: "OffSet",
    mixins: [detailCommonMixin],
    components: { Loading },
    props: ['showDialog', 'selectDetail', 'type'],
    data() {
        return {
            loading: false,
            sectionOpen: { contractInfo: true, offsetInfo: true, auditInfo: true },
            form: {
                id: '',
                status: '',
                rejectionReason: ''
            },
            rules: {
                status: [{ required: true, message: '审核状态不能为空', trigger: 'change' }],
                rejectionReason: [{ required: true, message: '驳回理由不能为空', trigger: 'change' }],
            }
        };
    },
    computed: {
        // 申请时的合同快照
        recordData() {
            return (this.selectDetail && this.selectDetail.data) || {};
        },
        applyData() {
            return JSON.parse(this.selectDetail?.dataChange) || {};
        },
    },
    watch: {
        selectDetail: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.form.id = newVal.id;
                }
            },
            immediate: true
        },
    },
    methods: {
        getContractColor,
        getStatusColor,
        async handleApprove() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    auditInfo(this.form).then(res => {
                        this.loading = false;
                        if (res.code === 200) {
                            this.$messageUi.success('提交成功');
                            this.$emit('submit', 'confirm');
                            if (this.form.status === 'SUCCESS') {
                                this.$messageUi.success('已通过');
                            } else {
                                this.$messageUi.success('已驳回');
                            }
                            this.$store.commit('right/setChangeRed', true);
                        }
                    }).catch(err => {
                        this.loading = false;
                    });
                } else {
                    this.$messageUi.error('信息填写不完整，请检查');
                }
            });
        },
        cancel() {
            this.$emit('submit');
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";
@import "@/assets/css/contractChangeSections.scss";

.section-body {
    padding: 4px 0;
}

.contract-number-text {
    color: #409eff;
    font-weight: 600;
}

.audit-section {
    background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}

.audit-form {
    padding: 16px;
}

.success-radio {
    margin-right: 20px;
}

.danger-radio {
    margin-right: 0;
}

.dialog-footer {
    text-align: right;
    padding-top: 10px;
}
</style>
